const INITIAL_STATE = [];

const Attributes = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SET_ATTRIBUTE":
      return action.payload;
    default:
      return state;
  }
};
export default Attributes;
